import {
  AssetRequest,
  UserOnboardingPostRequest,
} from '../../interfaces/AssetPacks';

export const mapUserFromOnboarding = (formData: AssetRequest) => {
  return {
    email: formData.email,
    geb_voornaam: formData.geb_voornaam,
    geb_naam: formData.geb_naam,
    geb_groep_id: Number(formData.geb_groep_id),
    geb_isRapport: false,
    geb_role: 'employee',
  };
};

export const userOnboardingMapper = (formData: AssetRequest) => {
  return {
    onboarding: {
      selectedPacks: { ...formData.assetPackSelection },
      selectedAssets: { ...formData.unassignedHardware },
    },
  };
};

export const MapUserForOnboarding = (
  formData: AssetRequest
): UserOnboardingPostRequest => {
  return {
    onboarding: userOnboardingMapper(formData),
    userData: mapUserFromOnboarding(formData),
    agree: formData.agree,
    cleaninstall:
      formData.cleanInstall && formData.unassignedHardware?.length > 0
        ? true
        : false,
    contact: formData.contact ? formData.contact : false,
    opmerking: formData.opmerking,
  };
};
